// @flow
import * as React from 'react';
import { Modal, ModalBody } from 'reactstrap';

import { Icon } from 'components/atoms';
import type { Profile } from './AdditionalInfoForm';
import AdditionalInfoForm from './AdditionalInfoForm';

// Utils
import { captureFocusUtilities } from 'utils/adaConfigurations/ModalFocusPrision';

import './AdditionalInfo.scss';

type Props = {
  /**
   * The info retrieved from the provider
   */
  profile: Profile | null,
  /**
   * Dealer country code
   */
  countryCode: string,
  /**
   * Toggles the visibility state of the modal
   */
  toggle?: () => void,
  /**
   * callback invoked when the user clicks on continue, it's assumed that at
   * this point the profile is populated correctly
   */
  onSubmit: (profile: Profile) => void,

  /**
   * Flag for modal
   */
  isOpen: boolean
};

class AdditionalInfo extends React.Component<Props> {
  static block = 'additional-info';
  constructor() {
    super();
    (this: any).modalContainer = React.createRef();
    (this: any).captureUtilities = captureFocusUtilities();
  }

  componentDidUpdate() {
    const { isOpen } = this.props;
    if (isOpen) {
      (this: any).captureUtilities.capture((this: any).modalContainer.current);
    } else {
      (this: any).captureUtilities.free();
    }
  }

  componentWillUnmount() {
    (this: any).captureUtilities.free();
  }

  modalContainer: React.Ref<any>;

  render() {
    const ns = AdditionalInfo.block;
    const {
      profile,
      countryCode,
      toggle,
      onSubmit,
      ...modalProps
    } = this.props;
    return (
      <Modal className={ns} toggle={toggle} {...modalProps}>
        <div ref={(this: any).modalContainer}>
          <ModalBody>
            <div className={`${ns}__dismiss d-md-none`} onClick={toggle}>
              <Icon type="close" />
            </div>
            {profile && (
              <AdditionalInfoForm
                countryCode={countryCode}
                profile={profile}
                onSubmit={onSubmit}
              />
            )}
          </ModalBody>
        </div>
      </Modal>
    );
  }
}

export default AdditionalInfo;



// WEBPACK FOOTER //
// ./src/components/pages/User/Social/AdditionalInfo/AdditionalInfo.js